export { default } from "./SwiperTopic"
